import { BrowserRouter } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import { setUser } from "./store/slices/userSlice.js";
import { extractRolesFromToken } from "./utils/extractRolesFromToken.js";
import { isTokenValid } from "./utils/validateToken.js";
import "react-toastify/dist/ReactToastify.css";


function App() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.user);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    // 🔁 Verify and sync auth state after store initialization
    // This runs once on mount to ensure Redux state is in sync with localStorage
    const storedAuth = localStorage.getItem("auth");

    if (storedAuth) {
      try {
        const { user, token } = JSON.parse(storedAuth);

        // Validate token before restoring
        if (token && user && isTokenValid(token)) {
          const roles = extractRolesFromToken(token);

          // Only dispatch if not already set (store might have initialized it)
          if (!isAuthenticated) {
            dispatch(
              setUser({
                user,
                roles,
                token,
              })
            );
          }
        } else {
          
          localStorage.removeItem("auth");
          localStorage.removeItem("token");
        }
      } catch (err) {
        // console.error("Failed to restore auth", err);
        localStorage.removeItem("auth");
        localStorage.removeItem("token");
      }
    }

    // Mark initialization as complete
    // Use setTimeout to ensure this runs after Redux store has initialized
    const timer = setTimeout(() => {
      setIsInitializing(false);
    }, 0);

    return () => clearTimeout(timer);
  }, [dispatch]); // Only run once on mount

  // Show loading state while initializing
  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      {/* App routes */}
      <AppRoutes />

      {/* Toast notifications */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </BrowserRouter>
  );
}

export default App;
